import styled from '@emotion/styled';
import MuiModal from '@mui/material/Modal';

export const Modal = styled(MuiModal)`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop {
    background-color: rgba(212, 209, 219, 0.5);  
  }
`;

export const Container = styled.div`
  width: 50%;
  box-shadow: 0px 20px 25px -5px rgba(23, 17, 39, 0.1), 0px 10px 10px -5px rgba(23, 17, 39, 0.04);
  background-color: white;

  border-radius: 8px;

  :focus-visible {
    outline: none;
  }

  ${({ theme }) => theme.media.tablet} {
    width: 80%;
  }

  ${({ theme }) => theme.media.mobile} {
    width: 100%;
    border: none;
  }
`;

export const Header = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: ${({ theme }) => `1px solid  ${theme.colors.neutral.shades.shade300}`};
  padding-top: ${({ theme }) => theme.spacings[4]};
  padding-bottom: ${({ theme }) => theme.spacings[4]};
  padding-left: ${({ theme }) => theme.spacings[4]};
  padding-right: ${({ theme }) => theme.spacings[4]};
`;

export const Footer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-top: ${({ theme }) => `1px solid  ${theme.colors.neutral.shades.shade300}`};
  padding: ${({ theme }) => theme.spacings[4]};
`;

export const ContentContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 90vh;
  overflow-y: auto;
  padding: ${({ theme }) => theme.spacings[4]};
  & p {
    text-align: center;
  }
`;